module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.0a191f83.ttf";